module.exports = __webpack_public_path__ + "img/awesome.6e6dca47.png";